var exports = {
  "K": "xa15a2ab7--46b256--icon",
};

module.exports = exports;
